import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { IThumbnailProvider } from '@3ddv/software-division-components';
import { DvmService } from './dvm.service';
import { PopoverDataTransformerService } from './popover-data-transformer.service';

/**
 * GroupSales-specific implementation of IThumbnailProvider.
 * This service provides thumbnails using the existing DvmService from GroupSales.
 */
@Injectable({
  providedIn: 'root',
})
export class GroupSalesThumbnailProviderService implements IThumbnailProvider {
  constructor(
    private dvmService: DvmService,
    private dataTransformer: PopoverDataTransformerService
  ) {}

  /**
   * Gets a thumbnail for the specified node ID.
   * @param nodeId - The node ID to get thumbnail for
   * @returns Observable of thumbnail URL
   */
  getThumbnail(nodeId: string): Observable<string> {
    // Use the data transformer to get the appropriate thumbnail section ID
    const thumbnailSectionId = this.dataTransformer.getThumbnailSectionId(nodeId);

    // Load thumbnail using existing DvmService
    return this.dvmService.loadThumbnail(thumbnailSectionId).pipe(
      map((img: HTMLImageElement) => img.src)
    );
  }
}
